import { useEffect, useState } from 'react';
import {
  IPaymentTypesDetails,
  savePaymentType,
  updatePaymentVisibilityStatus,
  getAllPaymentType,
  updatePaymentType,
} from 'wisestep-api';

import DialogWithInput from '../../../components/dialogWithInput';
import { useWorkspaceContext } from '../../../context';
import { AtsCustomAPIAccess, useAtsCustomAPIAccess } from '../../../hooks/useAtsCustomAPIAccess';
import { failed, success, warning } from '../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../utils/NotificationStore';
import InvoiceSettingsLayout, {
  ILabelWithStatus,
} from '../../invoicing/components/InvoiceSettingsLayout';
import {
  invoiceSettingsDefaultPayload,
  updateStatusQuery,
  updatePaymentTypeQuery,
  IDefaultValue,
  InvoiceBreadCrumbListAndTitle,
} from '../../invoicing/helper/InvocieSettingsHelper';

const PaymentTypeDetails = () => {
  const [paymentFileds, setPaymentFileds] = useState<IPaymentTypesDetails[]>([]);
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [openEditDialog, setOpenEditDialog] = useState<boolean>(false);
  const [editPaymentIndexValue, setEditPaymentIndexValue] = useState<number>(0);
  const [selectedValue, setSelectedValue] = useState<IPaymentTypesDetails>();

  const [flag, setFlag] = useState<boolean>(false);
  const setNotification = useNotificationStore((state) => state.setNotification);

  const workspaceContext = useWorkspaceContext();
  const { access: atsCustomAccessControl } = useAtsCustomAPIAccess([
    AtsCustomAPIAccess.MANAGE_INVOICE_SETTINGS,
  ]);

  const manageAccess = workspaceContext.owns || atsCustomAccessControl[0];

  useEffect(() => {
    const fetchData = async () => {
      const response = await getAllPaymentType();
      setPaymentFileds(response.data);
    };
    fetchData();
  }, [flag]);

  const getDefaultValue: IDefaultValue = {
    fieldOne: selectedValue?.name,
    fieldTwo: selectedValue?.description,
  };

  const categories: ILabelWithStatus[] =
    paymentFileds?.map((paymentFileds) => ({
      paymentType: paymentFileds.name,
      createdByName: paymentFileds.createdByName,
      visibility: paymentFileds.isActive,
    })) ?? [];

  const onUpdate = async (data: boolean, index: number) => {
    if (!manageAccess) {
      setNotification(warning('You do not have enough permissions to perform this action'));
      return;
    }
    const tempPayload = paymentFileds[index];
    updateStatusQuery.isActive = data;
    try {
      if (tempPayload.id) {
        await updatePaymentVisibilityStatus(tempPayload.id, updateStatusQuery);
        setNotification(success('Visibility status has been updated successfully !!'));
        setFlag(!flag);
      } else setNotification(warning('File Category Id not found !!'));
    } catch {
      setNotification(failed('Something went wrong , Please try again !!'));
    }
  };

  const onAddNewPaymentType = async (data) => {
    if (!manageAccess) {
      setNotification(warning('You do not have enough permissions to perform this action'));
      return;
    }
    const payload = { ...invoiceSettingsDefaultPayload };
    payload.name = data.fieldOne;
    payload.description = data.fieldTwo;
    payload.isActive = true;
    payload.isApproved = true;

    try {
      await savePaymentType(payload);
      setFlag(!flag);
      setNotification(success(`${data.fieldOne} has been added successfully !!`));
      setOpenDialog(false);
    } catch (error: any) {
      if (error.response.status === 400)
        setNotification(warning(`Oops , ${data.fieldOne} already exists!!`));
      else setNotification(failed('Something went wrong !!'));
    }
  };

  const getEditIndexValue = (index: number) => {
    setEditPaymentIndexValue(index);
    const tempPayload = paymentFileds[index];
    setSelectedValue(tempPayload);
    setOpenEditDialog(true);
  };

  const onUpdatePaymentType = async (data) => {
    const tempPayload = paymentFileds[editPaymentIndexValue];
    updatePaymentTypeQuery.name = data.fieldOne;
    updatePaymentTypeQuery.description = data.fieldTwo;

    try {
      if (tempPayload.id) {
        await updatePaymentType(tempPayload.id, updatePaymentTypeQuery);
        setNotification(success('Payment Type has been updated successfully !!'));
        setOpenEditDialog(false);
        setFlag(!flag);
      } else setNotification(warning('File Category Id not found !!'));
    } catch {
      setNotification(failed('Something went wrong , Please try again !!'));
    }
  };

  return (
    <>
      <InvoiceSettingsLayout
        BreadCrumbListAndTitle={InvoiceBreadCrumbListAndTitle['PAYMENT_TYPE']}
        backUrl={'/app-settings/invoice-module'}
        headerList={['Payment Type', 'Visibility', 'Created By', 'Edit']}
        dataCallback={(data: boolean, index: number) => onUpdate(data, index)}
        itemsList={categories}
        addButtonText="Payment Type"
        handleAddButton={() => setOpenDialog(true)}
        handleEditButton={(index: number) => getEditIndexValue(index)}
        isInvoicePaymentType={true}
      />
      {openDialog && (
        <DialogWithInput
          openDialog={openDialog}
          closeDialog={() => setOpenDialog(false)}
          onInput={(data) => onAddNewPaymentType(data)}
          name="Payment Type"
          extraField={true}
          addPlaceholder1={'Enter Payment Type'}
          addPlaceholder2={'Enter Description'}
          isPaymentTypeComp={true}
        />
      )}

      {openEditDialog && selectedValue && (
        <DialogWithInput
          openDialog={openEditDialog}
          closeDialog={() => setOpenEditDialog(false)}
          onInput={(data) => onUpdatePaymentType(data)}
          name="Payment Type"
          extraField={true}
          addPlaceholder1={'Enter Payment Type'}
          addPlaceholder2={'Enter Description'}
          isEdit={true}
          defaultValue={getDefaultValue}
          isPaymentTypeComp={true}
        />
      )}
    </>
  );
};

export default PaymentTypeDetails;
